import { useState, createContext } from 'react';
import { api } from '@/utils/api';
import { useEventListener } from '@/hooks';
import { ComplianceRequest } from '@/types';

type ComplianceRequestContextType = {
  complianceRequest: ComplianceRequest | undefined;
  setComplianceRequest: React.Dispatch<
    React.SetStateAction<ComplianceRequest | undefined | null>
  >;
  complianceRequestList: {
    loaded: boolean;
    loading: boolean;
    requests: ComplianceRequest[];
  };
};

const defaultContextValue: ComplianceRequestContextType = {
  complianceRequest: undefined,
  setComplianceRequest: () => {},
  complianceRequestList: {
    loaded: false,
    loading: false,
    requests: [],
  },
};

export const ComplianceRequestContext =
  createContext<ComplianceRequestContextType>(defaultContextValue);

export function useComplianceRequestContext() {
  const [complianceRequest, setComplianceRequest] = useState<
    ComplianceRequest | undefined
  >();
  const [complianceRequestList, setComplianceRequestList] = useState<{
    loaded: boolean;
    loading: boolean;
    requests: ComplianceRequest[];
  }>({
    loaded: !!api.compliance.complianceRequests,
    loading: !!api.compliance.complianceRequests,
    requests: api.compliance.complianceRequests || [],
  });

  useEventListener(api.compliance.events.ComplianceRequestsLoading, () =>
    setComplianceRequestList((prev) => ({ ...prev, loading: true })),
  );
  useEventListener(api.compliance.events.ComplianceRequestsLoaded, () => {
    setComplianceRequestList((prev) => ({
      ...prev,
      loaded: true,
      loading: false,
      requests: api.compliance.complianceRequests,
    }));
  });
  useEventListener(api.compliance.events.ComplianceRequestsChanged, () =>
    setComplianceRequestList((prev) => ({
      ...prev,
      requests: api.compliance.complianceRequests,
    })),
  );
  return {
    complianceRequest,
    setComplianceRequest,
    complianceRequestList,
  };
}
